import React, { useContext } from "react";
import { useStaticQuery, graphql } from "gatsby";
import styled from "@emotion/styled";
import Image from "gatsby-image";
import Container from "@src/components/Container";
import { Button, theme } from "@src/components/nessie-web";
import { Text } from "@src/components/Text";
import { TranslationContext } from "@src/components/translation/TranslationContext";
import { mediaQueries } from "@src/styles/theme";
import { Box } from "@src/components/Boxes";

const BgImage = styled(Image)`
  width: 100%;
  height: auto;
  margin-bottom: 36px
  }
`;

const HTMLContainer = styled(Container)`
  margin-bottom: 40px;
  h1,
  h2 {
    font-size: 24px;
    ${mediaQueries[0]} {
      font-size: 42px;
    }
  }
`;

const Title = ({ children }) => (
  <Text color="white" fontSize={[16, 20]} fontWeight={700} textAlign="center">
    {children}
  </Text>
);
const Background = ({ children, img }) => {
  return (
    <Box position="relative" marginBottom="72px">
      {img}
      <Container>{children}</Container>
    </Box>
  );
};

const PageSweepstake = () => {
  const trContext = useContext(TranslationContext);
  const t = (path: string) => trContext.translate(`directus.page_sweepstakes2.${path}`);

  const data = useStaticQuery(graphql`
    query {
      directus {
        page_sweepstakes2 {
          hero_image {
            id
            file {
              childImageSharp {
                fluid(maxWidth: 1200, quality: 90) {
                  ...GatsbyImageSharpFluid_noBase64
                }
              }
            }
          }
        }
      }
    }
  `);

  return (
    <>
      <Box backgroundColor={theme.colors.aqua50} padding={[18, 36]}>
        <Container>
          <Title>{t("hero_heading")}</Title>
        </Container>
      </Box>
      <Background
        img={
          <BgImage
            fluid={data.directus.page_sweepstakes2.hero_image.file.childImageSharp.fluid}
            alt="Mojo carrying a box of mojo plushies"
          />
        }
      >
        <Box margin="auto" width="50%" minWidth="300px">
          <Button href={t("button_url")}>{t("button_label")}</Button>
        </Box>
      </Background>
      <HTMLContainer>{t("legal_text")}</HTMLContainer>
    </>
  );
};

export default PageSweepstake;
